import React from "react";
import { Switch, Route } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import MonumBarang from "../pages/monitoring/";
import MonumDoc from "../pages/monitoring/doc";
import CCTVMonitoring from "../pages/cctv/";
import UserActivityLog from "../pages/monitoring/UserActivityLog";
import AntiFraud from "../pages/monitoring/AntiFraud";

const MonitoringRouter = () => {
  return (
    <TransitionGroup>
      <CSSTransition classNames="fadein" timeout={300}>
        <Switch>
          <Route path="/monitoring/stock" exact component={MonumBarang} />
          <Route path="/monitoring/stock/doc" exact component={MonumDoc} />
          <Route path="/monitoring/cctv" exact component={CCTVMonitoring} />
          <Route
            path="/monitoring/user-activity"
            exact
            component={UserActivityLog}
          />
          <Route path="/monitoring/anti-fraud" exact component={AntiFraud} />
          {/* <Route path="/other/adjustment/add" component={AdjustmentForm} />
          <Route path="/other/opname" exact component={Opname} />
          <Route path="/other/opname/add" component={OpnameForm} />
          <Route path="/other/pindah-lot/" component={PindahLot} />
          <Route path="/other/pindah/add" component={PindahLotForm} /> */}
        </Switch>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default MonitoringRouter;
